<template>
  <div id="userdetail-page" class="mb-5">
    <b-card>
      <b-row>
        <b-col md="12">
          <h3>{{ $route.name }}</h3>
          <b-breadcrumb>
            <b-breadcrumb-item
              ><router-link to="/dashboard">Dashboard</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item
              ><router-link to="/sales/items">Items</router-link></b-breadcrumb-item
            >
            <b-breadcrumb-item active>{{ $route.name }}</b-breadcrumb-item>
          </b-breadcrumb>
          <div class="border-bottom"></div>
        </b-col>
      </b-row>
      <div v-if="isLoading" style="z-index: 1000;">
        <div class="text-center text-primary my-2 h-100">
          <b-spinner class="align-middle"></b-spinner>
          <strong> Loading...</strong>
        </div>
      </div>
      <div v-else>
        <form v-on:submit.prevent="doSubmit()">
          <b-form-group class="mt-3 d-inline-flex px-2 align-items-center">
            <b-form-radio inline type="radio" v-model="model.productType" v-bind:value="'Product'"
              >Product</b-form-radio
            >
            <b-form-radio inline type="radio" v-model="model.productType" v-bind:value="'Service'"
              >Service</b-form-radio
            >
          </b-form-group>
          <div>
            <b-row>
              <b-col md="5">
                <label class="labels">item id </label>
                <i style="font-size: 12px;" class="text-warning font-weight-bold">*optional</i>
                <b-form-input
                  class="mb-3"
                  type="text"
                  v-if="this.$route.params.id !== null && this.$route.params.id !== undefined"
                  v-model="model.itemId"
                  di
                />
                <div class="form-group d-flex" v-else>
                  <input
                    type="text"
                    class="form-control w-25"
                    name="itemId"
                    v-model="model.itemId"
                    placeholder="Input number"
                  />
                  <!-- <p v-if="errors.has('itemId') !== null"></p> -->
                </div>
              </b-col>
              <b-col md="2"> </b-col>
              <b-col md="2">
                <label class="labels">Normal Price * </label>
                <div
                  class="form-group d-flex"
                  v-bind:class="errors.has('price') ? 'has-error' : ''"
                >
                  <money
                    v-bind:class="errors.has('price') ? 'is-invalid' : ''"
                    data-vv-as="price"
                    v-bind="money"
                    name="price"
                    v-model="model.normalPrice"
                    v-validate="'required'"
                    required
                    class="form-control text-right"
                    style="margin-top:15px!important;"
                    placeholder="Price"
                  ></money>

                  <p v-if="errors.has('price') !== null"></p>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="5">
                <label class="labels">Item Name *</label>
                <div class="form-group" v-bind:class="errors.has('name') ? 'has-error' : ''">
                  <textarea v-model="model.name" name="name" required class="form-control"></textarea>
                  <!-- <wysiwyg 
                    v-model="model.name"
                    id="textarea-auto-height"
                    max-rows="8"
                    v-bind:class="errors.has('name') ? 'is-invalid' : ''"
                    data-vv-as="name"
                    name="name"
                    wrap="soft"
                    v-validate="'required'"
                    placeholder="Enter Name"
                   /> -->

                  <p v-if="errors.has('name') !== null"></p>
                </div>
              </b-col>

              <b-col md="2"> </b-col>

              <b-col md="2">
                <label class="labels">Corporate Price *</label>
                <div
                  class="form-group d-flex"
                  v-bind:class="errors.has('corporatePrice') ? 'has-error' : ''"
                >
                  <!-- <b-form-input
                    style="width: 200px"
                    v-bind:class="errors.has('corporatePrice') ? 'is-invalid' : ''"
                    data-vv-as="corporatePrice"
                    name="corporatePrice"
                    v-model="model.corporatePrice"
                    v-validate="'required'"
                  /> -->
                   <money
                     v-bind:class="errors.has('corporatePrice') ? 'is-invalid' : ''"
                     data-vv-as="corporatePrice"
                     v-bind="money"
                     name="corporatePrice"
                     v-model="model.corporatePrice"
                     v-validate="'required'"
                     required
                     class="form-control text-right"
                     style="margin-top:15px!important;"
                     placeholder="Price"
                     ></money>

                  <p v-if="errors.has('corporatePrice') !== null"></p>
                </div>
              </b-col>
            </b-row>

            <div v-if="model.productType === 'Product'">
              <b-row class="mt-2">
                <b-col md="5">
                  <label class="labels">Supplier Reference</label>
                  <b-form-input
                    name="supplierReference"
                    v-model="model.itemSupplierReferenceName"
                    placeholder="example tokopedia..."
                  >
                  </b-form-input>
                </b-col>
                <!-- <b-button variant="primary" class="btn-custom" @click="showModalSupplier()" style="margin-top:1.9em"><font-awesome-icon icon="plus"/></b-button> -->
                <b-col md="2"></b-col>
                <b-col md="2" class="">
                  <div v-if="model.productType === 'Product'">
                    <label class="labels">Cost of Goods</label
                    ><i style="font-size: 12px;" class="text-warning font-weight-bold">*optional</i>
                    <div class="form-group d-flex">
                     <money
                       v-bind:class="errors.has('costOfGoods') ? 'is-invalid' : ''"
                       data-vv-as="costOfGoods"
                       v-bind="money"
                       name="costOfGoods"
                       v-model="model.costOfGoods"
                       v-validate="'required'"
                       required
                       class="form-control text-right"
                       style="margin-top:15px!important;"
                      placeholder="Price"
                     ></money>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="5">
                  <div v-if="model.productType === 'Product'">
                    <label class="labels">Merk</label>
                    <b-form-select name="merk" v-model="model.itemMerk" :options="merkList">
                    </b-form-select>
                  </div>
                </b-col>
                <div v-if="model.productType === 'Product'">
                  <b-button
                    variant="primary"
                    class="btn-custom"
                    @click="showModalMerk()"
                    style="margin-top:1.9em"
                    ><font-awesome-icon icon="plus"
                  /></b-button>
                </div>
              </b-row>
            </div>
            <b-row class="mt-2">
              <b-col md="5">
                <label class="labels">Item Category</label>
                <b-form-select
                  name="itemCategory"
                  v-model="model.itemCategory"
                  :options="categoryList"
                >
                </b-form-select>
              </b-col>
              <b-button
                variant="primary"
                class="btn-custom"
                @click="showModalItemCategory()"
                style="margin-top:1.9em"
                ><font-awesome-icon icon="plus"
              /></b-button>
              <b-col md="1" class="ml-5"></b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col md="5">
                <label class="labels">UNIT</label>
                <b-form-select name="itemCategory" v-model="model.itemUnit" :options="unitList">
                </b-form-select>
              </b-col>
              <b-button
                variant="primary"
                class="btn-custom"
                @click="showModalUnit()"
                style="margin-top:1.9em"
                ><font-awesome-icon icon="plus"
              /></b-button>
            </b-row>

            <b-row class="mt-2">
              <b-col md="5">
                <label class="labels">Upload Image</label> <br />
                <b-form-file
                  v-model="model.image"
                  placeholder="Choose a file or drop it here..."
                  drop-placeholder="Drop file here..."
                  @change="previewImage"
                ></b-form-file>
                <template v-if="preview">
                  <img :src="preview" class="w-50 mt-2" />
                </template>
                <template v-else>
                  <img class="w-50 mt-2" v-if="model.picture" :src="model.picture" />
                </template>
              </b-col>
            </b-row>

            <b-row class="mt-2">
              <b-col md="5">
                <label class="labels">Item Description</label>
                <div class="form-group">
                  <textarea v-model="model.itemDescription" class="form-control h-100"></textarea>
                  <!-- <wysiwyg 
                    v-model="model.itemDescription"
                    id="textarea-auto-height"
                    max-rows="8"
                    v-bind:class="errors.has('itemDescription') ? 'is-invalid' : ''"
                    data-vv-as="itemDescription"
                    name="itemDescription"
                    wrap="soft"
                    v-validate="'required'"
                    placeholder="Enter Name"
                   /> -->
                </div>
              </b-col>
            </b-row>

            <!-- <b-row>
                  <b-col md="5">
                  <label class="labels">Note</label>
                  <div class="form-group" v-bind:class="errors.has('note') ? 'has-error' : ''">
                    <b-form-textarea
                      rows="5"
                      type="text"
                      class="pb-0 mb-0 form-control"
                      v-model="model.note"
                      placeholder="Note"
                    />
                  </div>
                </b-col> -->
            <!-- </b-row> -->

            <b-row class="mt-5">
              <b-col md="6">
                <b-button variant="secondary" class="btn-back float-left" @click="goBack()"
                  ><font-awesome-icon icon="chevron-circle-left"></font-awesome-icon> Back</b-button
                >
              </b-col>
              <b-col md="6">
                <div v-if="loadingButton" class="float-right">
                  <b-button variant="warning" disabled>
                    <b-spinner small type="grow"></b-spinner>
                    Loading...
                  </b-button>
                </div>
                <div v-else>
                  <b-button
                    :variant="$route.params.id !== undefined ? 'warning' : 'primary'"
                    class="btn-back float-right"
                    type="submit"
                    ><font-awesome-icon icon="save"></font-awesome-icon>
                    {{ $route.params.id !== undefined ? 'Update' : 'Save' }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </form>
      </div>

      <b-modal id="bv-modal-add-category" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform text-center">Add Category</h5>
        </template>
        <form v-on:submit.prevent="doAddItemCategory()">
          <div class="d-block">
            <label><strong> Add Name Category *</strong></label>
            <b-form-input
              v-model="formData.name"
              required
              placeholder="Enter Name Category "
            ></b-form-input
            ><br />
            <label><strong> Add Code Category *</strong></label>
            <b-form-input
              v-model="formData.codeCategory"
              required
              placeholder="Enter Code Category "
            ></b-form-input
            ><br />
          </div>
          <b-button class="mt-4" @click="$bvModal.hide('bv-modal-itemcategory')"
            ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button
          >
          <b-button variant="primary" type="submit" class="mt-4 float-right"
            ><font-awesome-icon icon="save"></font-awesome-icon> Add</b-button
          >
        </form>
      </b-modal>
      <b-modal id="bv-modal-itemcategory" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform">Item Category</h5>
        </template>
        <div class="d-block">
          <b-button
            variant="primary"
            type="submit"
            @click="showModalAddCategory()"
            class="mb-2 float-right"
            ><font-awesome-icon icon="plus"></font-awesome-icon> Add</b-button
          >
          <b-table
            :fields="categoryFields"
            :items="itemsCategory"
            responsive="sm"
            class="align-items-center text-center"
          >
            <template #cell(codeCategory)="row">
              <p class="aligns-items-center my-auto">{{ row.item.codeCategory }}</p>
            </template>

            <template #cell(name)="row">
              <p class="align-items-center my-auto font-weight-bold">{{ row.item.name }}</p>
            </template>

            <template #cell(actions)="row">
              <a
                v-if="canDelete"
                v-on:click="deleteCategory(row)"
                v-b-tooltip.hover.left
                title="Delete"
                class="btn-op icon-delete mr-3"
              ></a>
              <a
                v-else
                v-on:click="deleteCategory(row)"
                v-b-tooltip.hover.left
                title="Delete"
                class="btn-op icon-delete mr-1"
              ></a>

              <a
                v-if="canEdit"
                v-on:click="showModalEditCategory(row)"
                v-b-tooltip.hover.right
                title="Edit"
                class="btn-op icon-edit mr-1"
              ></a>
              <a
                v-else
                v-on:click="showModalEditCategory(row)"
                v-b-tooltip.hover.right
                title="Edit"
                class="btn-op icon-edit mr-1"
              ></a>

              <!-- <a
                        v-if="canDelete"
                        v-on:click="editCategory(row)"
                        v-b-tooltip.hover.left
                        title="Delete"
                        class="btn-op icon-edit mr-1"
                      ></a> -->
            </template>
          </b-table>
        </div>
      </b-modal>

      <b-modal id="bv-modal-merk" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform text-center">Merk</h5>
        </template>
        <form v-on:submit.prevent="doAddMerk()">
          <div class="d-block align-items-center">
            <b-table
              :fields="fields"
              :items="items"
              responsive="sm"
              class="align-items-center text-center"
            >
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>

              <template #cell(name)="row">
                <p class="align-items-center my-auto font-weight-bold">{{ row.item.name }}</p>
              </template>

              <template #cell(actions)="row">
                <a
                  v-if="canDelete"
                  v-on:click="deleteMerk(row)"
                  v-b-tooltip.hover.left
                  title="Delete"
                  class="btn-op icon-delete mr-1"
                ></a>
                <a
                  v-else
                  v-on:click="deleteMerk()"
                  v-b-tooltip.hover.left
                  title="Delete"
                  class="btn-op icon-delete mr-1"
                ></a>
              </template>
            </b-table>
            <label for=""><strong>Add merk *</strong></label>
            <b-form-input
              v-model="formData.name"
              required
              placeholder="Input Merk Type Here"
            ></b-form-input
            ><br />
          </div>
          <b-button class="mt-4" @click="$bvModal.hide('bv-modal-merk')"
            ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button
          >
          <b-button variant="primary" type="submit" class="mt-4 float-right"
            ><font-awesome-icon icon="save"></font-awesome-icon> ADD</b-button
          >
        </form>
      </b-modal>

      <b-modal id="bv-modal-supplierReference" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform text-center text-primary text-bold">Supplier Reference</h5>
        </template>
        <form v-on:submit.prevent="addSupplierReference()">
          <div class="d-block align-items-center">
            <b-table
              :fields="supplierFields"
              :items="itemSupplier"
              :current-page="currentPage"
              :per-page="perPage"
              responsive="sm"
              class="align-items-center text-center"
            >
              <template #cell(index)="data">
                <p class="font-weight-bold">
                  {{ data.index + 1 }}
                </p>
              </template>

              <template #cell(name)="row">
                <p class="align-items-center my-auto font-weight-bold">{{ row.item.name }}</p>
              </template>

              <template #cell(url)="row">
                <a class="align-items-center my-auto font-weight-bold">{{ row.item.name }}</a>
              </template>

              <template #cell(actions)="row">
                <a
                  v-if="canDelete"
                  v-on:click="deleteSupplierReference(row)"
                  v-b-tooltip.hover.left
                  title="Delete"
                  class="btn-op icon-delete mr-1"
                ></a>
                <a
                  v-else
                  v-on:click="deleteSupplierReference()"
                  v-b-tooltip.hover.left
                  title="Delete"
                  class="btn-op icon-delete mr-1"
                ></a>
              </template>
            </b-table>
            <!-- <b-pagination  pills v-model="currentPage" 
                    :total-rows="totalRows"
                    per-page="perPage" size="sm"></b-pagination> -->
            <label class="labels mt-1 text-primary"
              ><strong>Add Supplier Reference *</strong></label
            >
            <b-form-input
              v-model="formData.name"
              required
              placeholder="Input Name Supplier"
            ></b-form-input
            ><br />
            <label class="labels mt-1 text-primary"><strong>Add Supplier URL *</strong></label>
            <b-form-input
              v-model="formData.url"
              required
              placeholder="Input URL Supplier"
            ></b-form-input
            ><br />
          </div>
          <!-- <b-button class="mt-4" @click="$bvModal.hide('bv-modal-supplierReference')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button> -->
          <b-button variant="primary" type="submit" class="mt-1 float-right"
            ><font-awesome-icon icon="save"></font-awesome-icon> ADD</b-button
          >
        </form>
      </b-modal>

      <b-modal id="bv-modal-unit" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform text-center text-primary text-bold">Unit</h5>
        </template>
        <form v-on:submit.prevent="addUnit()">
          <div class="d-block align-items-center">
            <b-table
              :fields="unitFields"
              :items="unitItem"
              :current-page="currentPage"
              :per-page="perPage"
              responsive="sm"
              class="align-items-center text-center"
            >
              <template #cell(index)="data">
                <p class="font-weight-bold">
                  {{ data.index + 1 }}
                </p>
              </template>

              <template #cell(name)="row">
                <p class="align-items-center my-auto font-weight-bold">{{ row.item.name }}</p>
              </template>

              <template #cell(note)="row">
                <a class="align-items-center my-auto font-weight-bold">{{ row.item.name }}</a>
              </template>

              <template #cell(actions)="row">
                <a
                  v-if="canDelete"
                  v-on:click="deleteUnit(row)"
                  v-b-tooltip.hover.left
                  title="Delete"
                  class="btn-op icon-delete mr-3"
                ></a>
                <a
                  v-else
                  v-on:click="deleteUnit()"
                  v-b-tooltip.hover.left
                  title="Delete"
                  class="btn-op icon-delete mr-1"
                ></a>
                <a
                  v-if="canEdit"
                  v-on:click="showModalEditUnit(row)"
                  v-b-tooltip.hover.right
                  title="Edit"
                  class="btn-op icon-edit mr-1"
                ></a>
                <a
                  v-else
                  v-on:click="showModalEditUnit(row)"
                  v-b-tooltip.hover.right
                  title="Edit"
                  class="btn-op icon-edit mr-1"
                ></a>
              </template>
            </b-table>
            <!-- <b-pagination  pills v-model="currentPage" 
                    :total-rows="totalRows"
                    per-page="perPage" size="sm"></b-pagination> -->
            <label class="labels mt-1 text-primary"><strong>Add Unit *</strong></label>
            <b-form-input
              v-model="formData.name"
              required
              placeholder="Input Unit Name"
            ></b-form-input
            ><br />
            <label class="labels mt-1 text-primary"><strong>Note *</strong></label>
            <b-form-input v-model="formData.note" required placeholder="Input note"></b-form-input
            ><br />
          </div>
          <!-- <b-button class="mt-4" @click="$bvModal.hide('bv-modal-supplierReference')"><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button> -->
          <b-button variant="primary" type="submit" class="mt-1 float-right"
            ><font-awesome-icon icon="save"></font-awesome-icon> ADD</b-button
          >
        </form>
      </b-modal>
      <b-modal id="bv-modal-category-edit" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform">Edit Category</h5>
        </template>
        <form v-on:submit.prevent="doEditCategory()">
          <div class="d-block">
            <label for=""><strong>Name *</strong></label>
            <b-form-input
              type="text"
              v-model="formData.name"
              required
              placeholder="Enter Name"
            ></b-form-input
            ><br />
            <label for=""><strong>Code Category *</strong></label>
            <b-form-input
              type="text"
              v-model="formData.codeCategory"
              required
              placeholder="Enter Value"
            ></b-form-input>
          </div>
          <b-button class="mt-4" @click="$bvModal.hide('bv-modal-category-edit')"
            ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button
          >
          <b-button variant="warning" type="submit" class="mt-4 float-right"
            ><font-awesome-icon icon="save"></font-awesome-icon>Update</b-button
          >
        </form>
      </b-modal>

      <b-modal id="bv-modal-unit-edit" hide-footer>
        <template v-slot:modal-title>
          <h5 class="text-transform">Edit Unit</h5>
        </template>
        <form v-on:submit.prevent="doEditUnit()">
          <div class="d-block">
            <label for=""><strong>Name *</strong></label>
            <b-form-input
              type="text"
              v-model="formData.name"
              required
              placeholder="Enter Name"
            ></b-form-input
            ><br />
            <!-- <label for=""><strong>Code Category *</strong></label>
              <b-form-input
                type="text"
                v-model="formData.codeCategory"
                required
                placeholder="Enter Value"
              ></b-form-input> -->
          </div>
          <b-button class="mt-4" @click="$bvModal.hide('bv-modal-unit-edit')"
            ><font-awesome-icon icon="times"></font-awesome-icon> Cancel</b-button
          >
          <b-button variant="warning" type="submit" class="mt-4 float-right"
            ><font-awesome-icon icon="save"></font-awesome-icon>Update</b-button
          >
        </form>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import wysiwyg from 'vue-wysiwyg';
import Vue from 'vue';
import {Money} from 'v-money'
Vue.use(wysiwyg, {
  hideModules: {
    headings: false,
    code: false,
    link: false,
    image: false,
    table: false,
    unorderedList: false,
    separator: false,
    maxHeight: '100px',
  },
}); // config is optional. more below
export default {
  components: { Money },
  name: 'items-form',
  data() {
    return {
      preview: null,
      loadingButton: false,
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      fields: [
        { key: 'index', label: 'No' },
        {
          key: 'name',
          label: 'Merk Name',
        },
        {
          key: 'actions',
          label: '',
        },
      ],
      canDelete: {
        type: Boolean,
        required: false,
        default: true,
      },

       //formatter curency
      money: {
          thousands: '.',
          precision: 0,
          masked: false
        },

      canEdit: {
        type: Boolean,
        required: false,
        default: true,
      },

      categoryFields: [
        {
          key: 'codeCategory',
          label: 'Code',
          class: 'text-bold',
        },
        {
          key: 'name',
          label: 'Category Name',
        },
        {
          key: 'actions',
          label: '',
        },
      ],
      supplierFields: [
        {
          key: 'supplierId',
          label: 'No ID',
          class: 'text-secondary',
        },
        {
          key: 'name',
          label: 'Supplier Name',
          class: 'text-secondary',
        },
        {
          key: 'phone',
          label: 'URL',
          class: 'text-secondary',
        },
        {
          key: 'actions',
          label: '',
        },
      ],
      unitFields: [
        {
          key: 'index',
          label: 'No Id',
        },
        {
          key: 'name',
          label: 'Unit Name',
        },
        {
          key: 'actions',
          label: '',
        },
      ],
      unitList: [],
      unitItem: [],
      items: [],
      itemsCategory: [],
      itemSupplier: [],
      productType: 'Product',
      isLoading: false,
      // isLoadingBranch: false,
      // isLoadingBranchModal: false,
      apiUrl: {
        itemList: window.AppConfig.apiUrl + 'item-list',
      },
      model: {
        productType: 'Product',
        name: '',
        itemId: '',
        itemCategory: '',
        itemMerk: '',
        itemUnit: [],
        corporatePrice: 0,
        normalPrice: 0,
        itemSupplierReference: null,
        itemSupplierReferenceName: '',
        itemDescription: null,
        image: '',
        picture: '',
        preview: null,
        costOfGoods: 0,
      },
      uuidCategory: '',
      uuidUnit: '',
      categoryList: [
        {
          value: 'Material',
          text: 'Material',
        },
        {
          value: 'Hard Things',
          text: 'Hard Things',
        },
      ],
      merkList: [
        {
          value: 'Lenovo ThinkPad',
          text: 'Lenovo ThinkPad',
        },
        {
          value: 'Macbook Pro 2020',
          text: 'Macbook Pro',
        },
      ],
      options: [
        {
          value: 'true',
          text: 'Yes',
        },
        {
          value: 'false',
          text: 'No',
        },
      ],
      supplierList: [],

      companyList: [],

      modelValidations: {
        // branch: {
        //   required: true
        // },
        // itemCategory: {
        //   required: true
        // },
        // company: {
        //   required: true
        // },
      },
      formData: {
        name: null,
        codeCategory: '',
        note: null,
      },
      currencyList: [
        {
          value: '',
          text: 'Please Select Currency',
        },
        {
          value: 'Rp',
          text: 'Rp',
        },
      ],
      currencyListed: [
        {
          value: '',
          text: 'Please Select Currency',
        },
        {
          value: 'Rp',
          text: 'Rp',
        },
        {
          value: 'RM',
          text: 'RM',
        },
      ],
      // timezone: '',
    };
  },
  watch: {
    // 'model.company' (value) {
    //   this.getBranch(value)
    // },
    // 'formData.company' (value) {
    //   this.getBranched(value)
    // },
  },
  mounted() {
    this.getSupplier();
    this.getItemCategory();
    this.getMerk();
    this.initData();
    this.getUnit();
    // this.romanize()
    this.getFullYear();
  },
  methods: {
    initData() {
      if (this.$route.params.id !== undefined) {
        this.getDetail();
        this.getUnit();
        this.getSupplier();
      }
    },
    getDetail() {
      this.isLoading = true;
      this.$http.get(this.apiUrl.itemList + '/' + this.$route.params.id).then((response) => {
        this.model.itemId =
          response.data.itemId !== null && response.data.itemId !== 'null'
            ? response.data.itemId
            : '-';
        this.model.productType = response.data.productType;
        this.model.name =
          response.data.name !== null && response.data.name !== 'null' ? response.data.name : '-';
        this.model.itemCategory =
          response.data.itemCategory !== null ? response.data.itemCategory.uuid : '-';
        this.model.unitLabel =
          response.data.unitLabel !== null && response.data.unitLabel !== 'null'
            ? response.data.unitLabel
            : '-';
        this.model.itemSupplierReferenceName =
          response.data.itemSupplierReferenceName !== null &&
          response.data.itemSupplierReferenceName !== ''
            ? response.data.itemSupplierReferenceName
            : '-';
        this.model.normalPrice =
          response.data.normalPrice !== null && response.data.normalPrice !== 'null'
            ? response.data.normalPrice
            : '-';
        this.model.corporatePrice =
          response.data.corporatePrice !== null && response.data.corporatePrice !== 'null'
            ? response.data.corporatePrice
            : '-';
        this.model.costOfGoods =
          response.data.costOfGoods !== null && response.data.costOfGoods !== 'null'
            ? response.data.costOfGoods
            : '-';
        this.model.itemMerk = response.data.itemMerk !== null ? response.data.itemMerk.uuid : '-';
        this.model.itemUnit = response.data.itemUnit !== null ? response.data.itemUnit.uuid : '-';
        // this.model.image = response.data.image;
        this.model.picture = response.data.image;
        this.model.itemDescription =
          response.data.itemDescription !== null ? response.data.itemDescription : '-';
        this.isLoading = false;
      });
    },

    getSupplier() {
      this.$http.get(window.AppConfig.apiUrl + 'item-supplier-reference').then((resp) => {
        this.supplierList = [];
        this.itemSupplier = [];
        resp.data._embedded.item_supplier_reference.forEach((data) => {
          this.itemSupplier = resp.data._embedded.item_supplier_reference;
          this.totalRows = resp.data.length;
          this.supplierList.push({
            value: data.uuid,
            text: data.name,
          });
          // this.timezone = data.account.timezone
        });
      });
    },

    previewImage: function(event) {
      var input = event.target;
      if (input.files) {
        var reader = new FileReader();
        reader.onload = (e) => {
          this.preview = e.target.result;
        };
        this.model.image = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },

    showModalAddCategory() {
      this.formData.name = null;
      this.formData.codeCategory = '';
      this.$bvModal.show('bv-modal-add-category');
    },

    showModalItemCategory() {
      this.formData.name = null;
      this.formData.codeCategory = '';
      this.$bvModal.show('bv-modal-itemcategory');
    },

    showModalEditCategory(row) {
      this.uuidCategory = row.item.uuid;
      if (row !== undefined) {
        this.$bvModal.show('bv-modal-category-edit');
        this.formData.name = row.item.name;
        this.formData.codeCategory = row.item.codeCategory;
        //  console.log('ini row', this.uuidTax);
      } else {
        console.log('no data rowuuid :');
      }
    },

    doEditCategory() {
      this.isLoading = true;
      this.$http
        .patch(window.AppConfig.apiUrl + 'item-category' + '/' + this.uuidCategory, {
          name: this.formData.name,
          codeCategory: this.formData.codeCategory,
        })
        .then(() => {
          this.isLoading = false;
          this.formData.name = null;
          this.formData.codeCategory = null;
          this.$bvModal.hide('bv-modal-category-edit');
          this.getItemCategory();
          this.$store.dispatch('notification/success', 'Category has been update');
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    doAddItemCategory() {
      this.isLoading = true;
      let model = {
        name: this.formData.name,
        codeCategory: this.formData.codeCategory,
      };
      this.$http
        .post(window.AppConfig.apiUrl + 'item-category', model)
        .then(() => {
          this.isLoading = false;
          this.formData.name = null;
          this.formData.codeCategory = null;
          this.formData.branch = null;
          this.formData.currency = null;
          this.$bvModal.hide('bv-modal-add-category');
          this.getItemCategory();
          this.$store.dispatch('notification/success', 'Item Category has been added');
        })
        .catch((error) => {
          this.isLoading = true;
          this.$store.dispatch('notification/error', error);
        });
    },
    getItemCategory() {
      this.$http.get(window.AppConfig.apiUrl + 'item-category?limit=100').then((response) => {
        this.itemsCategory = [];
        this.categoryList = [
          {
            value: null,
            text: 'Please Select Item Category',
          },
        ];
        response.data._embedded.item_category.forEach((data) => {
          this.itemsCategory = response.data._embedded.item_category;
          this.categoryList.push({
            value: data.uuid,
            text: data.name,
          });
        });
      });
    },

    deleteCategory(row) {
      this.isLoading = true;
      this.$http
        .delete(window.AppConfig.apiUrl + 'item-category' + '/' + row.item.uuid)
        .then(() => {
          this.isLoading = false;
          // this.$bvModal.hide('bv-modal-catego')
          this.getItemCategory();
          this.$store.dispatch('notification/success', 'Item Category deleted successfull');
        })
        .catch((error) => {
          // this.isLoading = true
          this.$store.dispatch('notification/error', error);
        });
    },

    showModalMerk() {
      this.formData.name = null;
      this.$bvModal.show('bv-modal-merk');
    },

    doAddMerk() {
      this.isLoading = true;
      let model = {
        name: this.formData.name,
      };
      this.$http
        .post(window.AppConfig.apiUrl + 'item-merk', model)
        .then(() => {
          this.isLoading = false;
          this.formData.name = null;
          // this.$bvModal.hide('bv-modal-merk')
          this.getMerk();
          this.$store.dispatch('notification/success', 'Merk has been added');
        })
        .catch((error) => {
          this.isLoading = true;
          this.$store.dispatch('notification/error', error);
        });
    },

    deleteMerk(row) {
      this.isLoading = true;
      this.$http
        .delete(window.AppConfig.apiUrl + 'item-merk' + '/' + row.item.uuid)
        .then(() => {
          this.isLoading = false;
          this.$bvModal.hide('bv-modal-merk');
          this.getMerk();
          this.$store.dispatch('notification/success', 'Merk deleted successfull');
        })
        .catch((error) => {
          // this.isLoading = true
          this.$store.dispatch('notification/error', error);
        });
    },

    getMerk() {
      this.$http.get(window.AppConfig.apiUrl + 'item-merk').then((response) => {
        this.items = [];
        this.merkList = [
          {
            value: null,
            text: 'Please Select Merk',
          },
        ];
        response.data._embedded.item_merk.forEach((data) => {
          this.items = response.data._embedded.item_merk;
          this.merkList.push({
            value: data.uuid,
            text: data.name,
          });
        });
      });
    },

    showModalSupplier() {
      this.formData.name = null;
      this.formData.url = null;
      this.$bvModal.show('bv-modal-supplierReference');
    },

    addSupplierReference() {
      this.isLoading = true;
      let model = {
        name: this.formData.name,
        url: this.formData.url,
      };
      this.$http
        .post(window.AppConfig.apiUrl + 'item-supplier-reference', model)
        .then(() => {
          this.isLoading = false;
          (this.formData.name = null), (this.formData.url = null), this.getSupplier();
          this.$store.dispatch('notification/success', 'Supplier Reference has been added');
        })
        .catch((error) => {
          this.$store.dispatch('notification/error', error);
        });
    },

    deleteSupplierReference(row) {
      this.isLoading = true;
      this.$http
        .delete(window.AppConfig.apiUrl + 'item-supplier-reference' + '/' + row.item.uuid)
        .then(() => {
          this.isLoading = false;
          this.$store.dispatch('notification/success', 'Supplier deleted successfull');
          this.getSupplier();
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    showModalUnit() {
      this.formData.name = null;
      this.formData.note = null;
      this.$bvModal.show('bv-modal-unit');
    },

    showModalEditUnit(row) {
      this.uuidUnit = row.item.uuid;
      if (row !== undefined) {
        this.$bvModal.show('bv-modal-unit-edit');
        this.formData.name = row.item.name;
        // this.formData.note = row.item.note;
        //  console.log('ini row', this.uuidTax);
      } else {
        console.log('no data rowuuid :');
      }
    },

    getUnit() {
      this.$http.get(window.AppConfig.apiUrl + 'item-unit').then((resp) => {
        this.unitItem = [];
        this.unitList = [
          {
            value: null,
            text: 'Please select Unit',
          },
        ];
        resp.data._embedded.item_unit.forEach((data) => {
          this.unitItem = resp.data._embedded.item_unit;
          this.unitList.push({
            value: data.uuid,
            text: data.name,
          });
        });
      });
    },

    doEditUnit() {
      this.isLoading = true;
      this.$http
        .patch(window.AppConfig.apiUrl + 'item-unit' + '/' + this.uuidUnit, {
          name: this.formData.name,
        })
        .then(() => {
          this.isLoading = false;
          this.formData.name = null;
          this.formData.note = null;
          this.$bvModal.hide('bv-modal-unit-edit');
          this.getUnit();
          this.$store.dispatch('notification/success', 'Category has been update');
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    addUnit() {
      this.isLoading = true;
      let model = {
        name: this.formData.name,
        note: this.formData.note,
      };
      this.$http
        .post(window.AppConfig.apiUrl + 'item-unit', model)
        .then(() => {
          this.isLoading = false;
          this.$store.dispatch('notification/success', 'Unit has been added');
          this.getUnit();
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    deleteUnit(row) {
      this.isLoading = true;
      this.$http
        .delete(window.AppConfig.apiUrl + 'item-unit' + '/' + row.item.uuid)
        .then(() => {
          this.isLoading = false;
          this.$store.dispatch('notification/success', 'Unit deleted successfull');
          this.getUnit();
        })
        .catch((error) => {
          this.isLoading = false;
          this.$store.dispatch('notification/error', error);
        });
    },

    // onChange(e) {
    //   const file = e.target.files[0]
    //   this.model.image = file
    //   this.item.image = URL.createObjectURL(file)
    // },

    getMonth(value) {
      if (value !== null) {
        return this.$moment(value).format('MM');
      } else {
        return '-';
      }
    },

    // price(value){
    //   let val = (value)
    //   .replace(/,/g, "");
    //   return val.parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    // },

    formatUang(subject) {
      // return subject.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      this.points = Number(subject.replace(/\D/g, ''));
      return subject == '0' ? '' : this.points.toLocaleString();
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(2).replace(',', '.');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },

    getFullYear(value) {
      if (value !== null) {
        return this.$moment(value).format('MM');
      } else {
        return '-';
      }
    },

    getDateTime(value) {
      if (value !== null) {
        return this.$moment(value).format('YYYY-MM-DD HH:mm A');
      } else {
        return '-';
      }
    },
    goBack() {
      window.goBack(this);
    },
    // changeSwitch (val) {
    //   if(val){
    //     this.model.isHq = !val
    //     this.hq = this.isHq[0].text
    //   }else{
    //     this.model.isHq = !val
    //     this.hq = this.isHq[1].text
    //   }
    // },

    doSubmit() {
      this.$validator.validateAll().then((res) => {
        this.loadingButton = true;
        if (res) {
          let formData = new FormData();
          formData.append('productType', this.model.productType);
          formData.append('itemId', this.model.itemId);
          if (this.model.image !== '') {
            formData.append('image', this.model.image);
          }
          formData.append('name', this.model.name);
          formData.append('normalPrice', Number(this.model.normalPrice));
          formData.append('corporatePrice', Number(this.model.corporatePrice));
          formData.append('costOfGoods', Number(this.model.costOfGoods));
          formData.append('itemMerk', this.model.itemMerk);
          formData.append('itemUnit', this.model.itemUnit);
          formData.append('itemDescription', this.model.itemDescription);
          formData.append('itemCategory', this.model.itemCategory);
          formData.append('itemSupplierReferenceName', this.model.itemSupplierReferenceName);
          if (this.$route.params.id !== undefined) {
            this.$http
              .patch(this.apiUrl.itemList + '/' + this.$route.params.id, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then((response) => {
                this.$store.dispatch('notification/success', 'Item has been updated');
                window.location.href = document.URL.replace('/edit', '');
                console.log(response);
              })
              .catch((error) => {
                this.$store.dispatch('notification/error', error);
                this.loadingButton = false;
              });
          } else {
            this.loadingButton = true;
            this.$http
              .post(this.apiUrl.itemList, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              })
              .then((response) => {
                this.$store.dispatch('notification/success', 'Item has been added.');
                window.location.href = document.URL.replace('/create', '/' + response.data.uuid);
              })
              .catch((error) => {
                this.$store.dispatch('notification/error', error);
                this.loadingButton = false;
              });
          }
        } else {
          this.loadingButton = false;
          // eslint-disable-next-line no-undef
          swal('', 'Please fill the required fields!', 'info', {
            buttons: false,
            timer: 2000,
          });
        }
      });
    },

    //format mata uang
  },
};
</script>
<style scoped>
@import '~vue-wysiwyg/dist/vueWysiwyg.css';
</style>
